import { css } from '@emotion/react';
import type { ReactElement } from 'react';
import { ChatSuggestion } from 'sdk';

import { styled } from '../../../../../styled';
import { Theme } from '../../../../../theme/interface/detailed';

const styles = css`
	text-align: center;
`;

type Interface = {
	className: string;
	suggestion: ChatSuggestion;
	onClick: VoidFunction;
};

const Component = ({ className, suggestion, onClick }: Interface): ReactElement => (
	<div className={className} onClick={onClick}>
		{suggestion.text}
	</div>
);

export const Suggestion = styled(Component)(
	({ theme }: { theme: Theme }) => ({
		...theme.chat.messages.suggestion,
	}),
	styles
);
